import { IconArrowBackUp, IconEyeOff } from '@tabler/icons-react'
import { Tooltip } from 'antd'
import styled from 'styled-components'

import { Button } from '@/components/shared-components/BUI/Button'
import { useSupport } from '@/context/supportContext'

import { buildPassTheme } from 'src/styles/theme'

const BannerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.colour.primary._50};
  border: 1px solid ${({ theme }) => theme.colour.primary._100};
  border-top: 0;
  color: ${({ theme }) => theme.colour.primary._700};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.125rem 2.5rem;
  border-bottom-left-radius: 999px;
  border-bottom-right-radius: 999px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  z-index: 1030; // same as old Ant header
`

const TextWrapper = styled.div`
  ${({ theme }) => theme.font.caption02}
  font-weight: 600;
  text-align: center;
  flex: 1;
`

const SupportModeBanner: React.FC = () => {
  const {
    showBanner,
    isInSupportMode,
    originalBuilder,
    resetToOriginalBuilder,
    toggleBanner,
  } = useSupport()

  return isInSupportMode && showBanner ? (
    <BannerWrapper>
      <Tooltip
        placement="bottom"
        title={`Reset builder back to \n ${originalBuilder.name}`}
      >
        <Button
          size="small"
          shape="circle"
          variant="secondary-text"
          icon={
            <IconArrowBackUp
              size={16}
              color={buildPassTheme.colour.primary._700}
            />
          }
          onClick={resetToOriginalBuilder}
        />
      </Tooltip>

      <TextWrapper>Support mode</TextWrapper>

      <Tooltip placement="bottom" title={`Close banner`}>
        <Button
          shape="circle"
          size="small"
          variant="secondary-text"
          icon={
            <IconEyeOff size={16} color={buildPassTheme.colour.primary._700} />
          }
          onClick={() => toggleBanner(false)}
        />
      </Tooltip>
    </BannerWrapper>
  ) : null
}

export default SupportModeBanner
